import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-leaveoptionpopup',
  templateUrl: './leaveoptionpopup.component.html',
  styleUrls: ['./leaveoptionpopup.component.css']
})
export class LeaveoptionpopupComponent implements OnInit {

  dateCustomClasses: DatepickerDateCustomClasses[];
  
  constructor(private toastr: ToastrService, private appService: AppdataService,
    public loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService,
    private datePipe: DatePipe,private productFindService: NgbModal) {
      this.dateCustomClasses = [
        { date: new Date(), classes: ['bg-warning'] },
      ];
     }

   
  //Save Validation
  submitted: boolean;
  successfully: boolean;
 
  isduplicate: boolean;

  

  leaveoptionform = new FormGroup({
   
    leaveid: new FormControl(0),
    returndt: new FormControl(null, Validators.required),
    returncommends: new FormControl('', Validators.required),
  
    
  });

  transpaymodeColl: any = [];

  
  @Input() leaveid:any=0;
  @Input() returndt: any;
  @Input() returncommends: any = '';

  
  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.leaveoptionform.reset();
    this.fnInitializeFormGroup();
  }


  fnInitializeFormGroup() {
    this.leaveoptionform.setValue({
      leaveid: this.leaveid,
      returndt: new Date(),
      returncommends: this.returncommends,      
    })
  }

  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;

    

      //Validate
      if (this.leaveoptionform.valid) {

        

        //Check
        var data = {
          leaveid:this.leaveid,
          returndt: this.fnFormatDatetime(this.leaveoptionform.get('returndt').value),
    
          returncommends: this.leaveoptionform.get('returncommends').value,
          modifiedby:this.loginService.fnGetModUserId(),   
        }
      this.appService.fnSetLeaveOption(data).subscribe(
        (res)=>{ 
          if(res.json().status===200){  
            this.emitData.emit('DONE');
            this.activeModal.close(true);
            }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err)=>{ 
          this.toastr.error('Error', err);
        });
      }
    }
     catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

    // //AddTransPaymode
    // private fnAddTransPaymode() {

    //   const modalRef = this.productFindService.open(LeaveoptionpopupComponent, { size: <any>'l' });
  
    //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    //     this.fngetTranspaymode();
  
    //     if (receivedEntry > 0) {
    //       this.transpaymentinfoform.patchValue({ transpaymodeid: receivedEntry })
    //     }
    //   });
  
    // }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
